import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';

import { CamtlAdminContactsComponent } from './camtl-admin-contacts/camtl-admin-contacts.component';
import { CamtlProjectsComponent } from './camtl-projects/camtl-projects.component';
import { CamtlSystemsComponent } from './systems/systems.component';

import { CamtlMaintenanceComponent } from './maintenance.component';
import { ProgramSetupComponent } from './program-setup/program-setup.component';
import { ManageDateTemplateComponent } from './manage-date-template/manage-date-template.component';
import { TimingChartControlComponent } from './timing-chart-control/timing-chart-control.component';

@NgModule({
    imports: [
        SharedModule,
    ],
    declarations: [
        CamtlMaintenanceComponent,
        CamtlProjectsComponent,
        CamtlAdminContactsComponent,
        CamtlSystemsComponent,
        ProgramSetupComponent,
        ManageDateTemplateComponent,
        TimingChartControlComponent,
    ],
})
export class CamtlMaintenanceModule { }
